// Pure route → shell-chrome derivations for AccountShell (variant / bleed /
// sidebar overlay). Kept out of App.tsx so the mapping is testable and stays
// in one place next to the route parser.
// Gallery-variant routes (DESIGN.md §GalleryAccountShell): top header, no
// legacy workspace sidebar. These routes use the gallery chrome so
// Activity/Settings/Run don't flash the old white sidebar when leaving Home.
export function isGalleryVariantRoute(route: string): boolean {
  return (
    // Home (`/`) is the one Personal Apps stage; the retired `/apps` and
    // `/apps/discover` aliases resolved to this same chrome so switching panes
    // never swapped the shell.
    route === "/" ||
    route === "/runners" ||
    route === "/settings" ||
    route.startsWith("/settings/") ||
    route.startsWith("/formations/") ||
    route === "/desktop" ||
    route.startsWith("/a/")
  );
}

// Routes whose main content is full-bleed by virtue of the ROUTE alone.
// Drives AccountShell's mainBleed prop.
export function isMainBleedRoute(route: string): boolean {
  return (
    route.startsWith("/a/") ||
    // Home owns its own padding (hero glow bleeds to the content edge).
    route === "/" ||
    // The Desktop landing keeps its own 1200px max-width layout.
    route === "/desktop" ||
    // The Instance embed frames the App full-bleed.
    (route.startsWith("/apps/") && route.endsWith("/open"))
  );
}

/**
 * Is this one of the Personal Apps surfaces?
 *
 * These get the stripped-back chrome: wordmark and avatar, no primary nav, no
 * site footer.
 */
export function isPersonalAppsSurface(route: string): boolean {
  // The invite landing page gets the stripped chrome: its visitor is looking
  // at somebody else's App, and a full site nav around it would invite them
  // to wander off instead.
  if (route.startsWith("/invite/")) return true;
  if (route.startsWith("/formations/")) return true;
  return route === "/" || route.startsWith("/apps/");
}
